import { render, staticRenderFns } from "./Bitrix24.container.vue?vue&type=template&id=8e2b339e&"
import script from "./Bitrix24.container.vue?vue&type=script&lang=ts&"
export * from "./Bitrix24.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports